import React from 'react'


const About = () => {

    

    return (

        <div className="about2-area">
            <div className="container">
                <h1 className="about-title">Welcome To Information Technology and Technical Education Council</h1>
                <p className="about-sub-title " style={{ textAlign: 'center' }}><b style={{ fontSize: 20 }}>Registered under Government
                    of India.</b><br />
                    ITT COUNCIL, Delhi is Provided Computer (IT) and Technical Courses Thorough Authorised Training Center (ATC)
                    and <br />Self Study Online Center (Online Video Tutorials), Conducted Online Exam of Short Terms Course and
                    Diploma
                    Course <br />after Examination Issue Certificate.<br />
                    Authorised Training Center In India and Out Of India</p>
            </div>
            <div className="container">
                <div className="row">
                    <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 wow fadeIn" data-wow-duration="2s" data-wow-delay=".1s">
                        <div className="service-box2">
                            <div className="service-box-icon">
                                <a href="#"><i className="fa fa-graduation-cap" aria-hidden="true" /></a>
                            </div>
                            <h3><a href="#">Scholarship Facility</a></h3>
                            <p style={{ textAlign: 'justify' }}>Get Scholarship From ITT-Council Upto 70% To 80% Based On Your Skills.
                                Participate State Leval
                                Scholarship Exam, Many Indian Student Belongs To Middle Class And Poor Families, ITT-Council Present
                                Special Scholarship Program..</p>
                        </div>
                    </div>
                    <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 wow fadeIn" data-wow-duration="2s" data-wow-delay=".4s">
                        <div className="service-box2">
                            <div className="service-box-icon">
                                <a href="#"><i className="fa fa-user" aria-hidden="true" /></a>
                            </div>
                            <h3><a href="#">E-Learning Facility</a></h3>
                            <p style={{ textAlign: 'justify' }}>A digital classroom world class education practices for students and
                                teacher to compete world,
                                E-Learning System, E-Notes, Video Tutorials, Digital Board, Latest Software, Online Exam Practice, and
                                Online Exams, Mobile Application for practice.</p>
                        </div>
                    </div>
                    <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 wow fadeIn" data-wow-duration="2s" data-wow-delay=".7s">
                        <div className="service-box2">
                            <div className="service-box-icon">
                                <a href="#"><i className="fa fa-book" aria-hidden="true" /></a>
                            </div>
                            <h3><a href="#">Self Study Open Institute</a></h3>
                            <p style={{ textAlign: 'justify' }}>Self Study Open Institute Presents by ITT-Council we are Provided online
                                Study Center by Video
                                Tutorials on Website and Mobile App and Registered Your Online Admission and Conducted Online Exam.
                                After Exam Issue Certificate more.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export {About}